import { render, staticRenderFns } from "./TheLoginLayout.vue?vue&type=template&id=bced3664&scoped=true&"
import script from "./TheLoginLayout.vue?vue&type=script&lang=js&"
export * from "./TheLoginLayout.vue?vue&type=script&lang=js&"
import style0 from "./TheLoginLayout.vue?vue&type=style&index=0&id=bced3664&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bced3664",
  null
  
)

export default component.exports